<template lang="pug">
div(style="background-color: #00000059; z-index: 99; width: 100%; height: 100%; left: 0; top: 0; position: absolute;")
  div.modal-box#risk-tips-alert
    .head {{ isDanger ? '风险不匹配警示函' : '风险揭示书' }}
    .main
      .content(style="padding: 10px 0;")
        div(v-if="!isDanger") 尊敬的投资者: {{ user.name }}<br/>
          | <br/>投资有风险。当您/贵机构认购或申购私募基金时，可能获得投资收益，但同时也面临着投资风险。
          | <br/>您/贵机构在做出投资决策之前，请仔细阅读本风险揭示书和基金合同、公司章程或者合伙协议(以下统称基金合同)，充分认识本基金的风险收益特征和产品特性，认真考虑基金存在的各项风险因素，并充分考虑自身的风险承受能力，理性判断并谨慎做出投资决策。
        div(v-if="isDanger") 尊敬的投资者: {{ user.name }}（{{ user.cardId }}）<br/>
          | <br/>经核实，您/贵机构申请预约的产品或服务风险等级为{{ level }}，您当前风险等级为{{ user.validType }}，{{ isLevelOne ? '属于' : '不属于' }}最低风险承受能力的普通投资者。
          | <br/>根据适当性匹配原则，该产品或者服务高于您/贵机构风险承受能力，我司特此向您/机构书面警示：购买该产品/服务，可能导致您/贵机构承担超出自身承受能力损失以及不利后果。
          | <br/>请您认真考虑相应风险，审慎决定购买该产品或服务，并确认投资者确认书。
    .foot
      span.confirm(@click="confirmClick") 我已了解风险，预约产品
</template>

<script>
import { mapState } from 'vuex'

export default {
  data () {
    return {}
  },
  props: ['pid', 'level'],
  computed: {
    ...mapState(['user']),
    isDanger () {
      if (this.level && this.user.validType) {
        let levelNum = this.level.replace(/[^0-9]/g, '')
        let typeNum = this.user.validType.replace(/[^0-9]/g, '')
        levelNum = parseInt(levelNum)
        typeNum = parseInt(typeNum)
        if (typeNum >= levelNum) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    isLevelOne () {
      return this.level.slice(1, 1) === '1'
    }
  },
  methods: {
    confirmClick () {
      this.$emit('confirm', { pid: this.pid })
    }
  }
}
</script>

<style scoped>
.modal-box {
  width: 50%;
  min-width: 800px;
  height: 600px;
  padding-left: 30px;
  padding-right: 30px;
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(255,255,255,.9);
  border: 1px solid #d4d4d4;
  border-radius: 6px;
  z-index: 99;
}

.modal-box .head {
  text-align: center;
  font-size: 1.1rem;
  padding: 20px 0;
  box-sizing: border-box;
  font-weight: 400;
  color: #D0121B;
  border-bottom: 1px solid #d4d4d4;
}

.modal-box .main .tips {
  padding: 8px 0;
  color: #D0121B;
  font-size: 0.9rem;
  line-height: 1.4;
  text-align: justify;
}

.strong {
  font-weight: 500;
}

.modal-box .main {
  height: 460px;
  text-align: justify;
  font-size: 0.9rem;
  line-height: 1.6;
  overflow: scroll;
}

.modal-box .foot {
  box-sizing: border-box;
  text-align: center;
  padding: 20px 0;
}

.modal-box .foot span {
  padding: 8px 40px;
  font-size: 0.84rem;
  color: white;
  cursor: default;
}

.modal-box .foot .confirm {
  border-radius: 6px;
  background-color: #D0121B;
  cursor: pointer;
}

.modal-box .foot .quit {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background-color: #f36b2b;
}

::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

</style>



// WEBPACK FOOTER //
// src/components/commons/RiskTipsAlert.vue